import { DATA_SOURCE_IDS } from '@discover-frontend/constants';
import {
  isSmGbTgi,
  isSmUsGwi,
  isSmUsMri,
  isSmWwGwi,
} from '@discover-frontend/utils';

export const isSocialPlusScope = () =>
  isSmUsMri() || isSmUsGwi() || isSmWwGwi() || isSmGbTgi();

export const resolveDefaultDataSource = (
  dataSource,
  isSocialPlus = isSocialPlusScope()
) =>
  isSocialPlus && dataSource === DATA_SOURCE_IDS.INSTAGRAM
    ? DATA_SOURCE_IDS.TWITTER
    : dataSource;
